import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function RouteTracker() {
  const location = useLocation();
  const lastPath = useRef(location.pathname);

  useEffect(() => {
    // Save ONLY the previous path, NOT the current
    localStorage.setItem("prev_route", lastPath.current);

    // Update lastPath to new current path
    lastPath.current = location.pathname;
  }, [location.pathname]);

  return null;
}
